import { ConditionViewerItem, ConditionViewerTerm } from '@customerio/pluma-components/react';
import type { TriggerCampaignNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { useCampaignName } from './message-condition';

type TriggerCampaignConditionProps = { node: TriggerCampaignNode; workspaceId: number };

/**
 * A `seg_attr` row, as Ember's legacy label words it
 * (`cio-condition-label-item/seg-attr`): `Trigger in <campaign>`.
 */
export function TriggerCampaignCondition({ node, workspaceId }: TriggerCampaignConditionProps) {
  const campaignName = useCampaignName(node.campaignId, undefined, workspaceId);
  const fallback = node.campaignId == null ? 'a campaign' : `campaign #${node.campaignId}`;
  return (
    <ConditionViewerItem icon={getIconForNode(node)}>
      <ConditionViewerTerm>Trigger</ConditionViewerTerm> in{' '}
      <ConditionViewerTerm>{campaignName ?? fallback}</ConditionViewerTerm>
    </ConditionViewerItem>
  );
}
